import {Component, OnChanges, OnInit, OnDestroy} from '@angular/core';
import { NgArcProgressService } from './ngarc-progress.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-ngarc-progress',
  templateUrl: './ngarc-progress.component.html',
  styleUrls: ['./ngarc-progress.component.scss']
})
export class NgArcProgressComponent implements OnInit, OnChanges, OnDestroy {

  arcRadius: number;
  arcSize: number;
  arcStart: number;
  arcStrokeWidth: number;
  positionX: number;
  positionY: number;
  strokeDashArray: number;
  strokeDashOffSet: number;
  fillValue: number;
  range: number;
  arcBackgroundColor: string;
  arcProgressColor: string;
  percentage: number;

  subscription: Subscription;

  formPercentageFilled$: Observable<number>;
  constructor(private ngArcProgressService: NgArcProgressService) {
    this.formPercentageFilled$ = this.ngArcProgressService.formPercentageFilled$;
    this.subscription = this.formPercentageFilled$.subscribe(percentageFilled => {
      this.percentage = Math.round(percentageFilled ? percentageFilled : 0);
      this.initArc();
    });
  }

  ngOnInit() {
    this.initArc();
  }

  ngOnChanges() {
    this.initArc();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  initArc() {
    this.arcBackgroundColor = 'lightgrey';
    this.arcProgressColor = '#523178';
    this.arcStrokeWidth = 10;
    this.arcSize = 100;
    this.arcRadius = (45 * this.arcSize) / 100;
    this.arcStart = 90;
    this.positionX = this.arcSize / 2;
    this.positionY = this.arcSize / 2;
    this.range = (this.arcStart / 88);
    this.strokeDashArray = this.arcRadius * Math.PI * this.range;
    this.strokeDashOffSet = (this.arcRadius * Math.PI * this.range * -1);
    this.fillValue = ((this.percentage * this.strokeDashArray) / 100) + this.strokeDashOffSet;
  }

  drawnArc(x, y, radius, startAngle, endAngle) {
    endAngle = endAngle - 0.0001;
    /*to be able to draw a full circle*/
    const start = this.polarToCartesian(x, y, radius, endAngle);
    const end = this.polarToCartesian(x, y, radius, startAngle);

    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

    const d = [
      'M', start.x, start.y,
      'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y
    ].join(' ');

    return d;
  }

  polarToCartesian(centerX, centerY, radius, angleInDegrees) {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

    return {
      x: centerX + (radius * Math.cos(angleInRadians)),
      y: centerY + (radius * Math.sin(angleInRadians))
    };
  }
}
